import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classcat';
import { isNil, isEmpty } from 'lodash';
import localforage from 'localforage';
import Api from 'services/Api';
import Chat from 'modules/Chat';
import Modals from 'modules/Modals';
import Online from 'components/Online';
import OfflineOverlay from 'components/OfflineOverlay';
import Dropdown from 'components/Dropdown';
import ConfirmModal from 'components/Confirm';
import MagicMove from 'components/Transitions/MagicMove';
import MessageList from './MessageList';
import UserList from './UserList';
import UserInput from './UserInput';
import './chat.css';

const { PRIVATE } = Chat.constants;

const isPrivate = (channel) => channel === undefined || channel === PRIVATE;

export class _Chat extends Component {
  constructor(props) {
    super(props);
    const { channelRefs, gameChannel, defaultChannel } = props;
    this.state = {
      opened: true,
      unseenMessages: 0,
      selectedChannel:
        channelRefs && channelRefs.includes(gameChannel) ? gameChannel : defaultChannel,
      // FIXME: The following only works because at 570 this instance is destroyed and another is
      // created in the mobile bingo middle. It needs a resize sensor or similar.
      prevVpWidth: document.body.getBoundingClientRect().width
    };
  }

  componentDidMount() {
    const { prevVpWidth, selectedChannel } = this.state;
    let isOpened = true;

    this.props.initialize(selectedChannel, this.props.subscriptions);
    localforage.config({ name: 'mrq_chat' });
    localforage.getItem('opened', (err, value) => {
      isOpened = !isNil(value) ? value : true;
    });
    if (prevVpWidth <= 570) {
      isOpened = false;
    }
    this.setState({ opened: isOpened });
    this.update();
  }

  componentDidUpdate(prevProps) {
    const { channelRefs, gameChannel, defaultChannel } = this.props;
    if (channelRefs !== prevProps.channelRefs) {
      if (channelRefs.includes(PRIVATE)) {
        this.changeChannel(PRIVATE);
      }
      if (channelRefs.includes(gameChannel)) {
        this.changeChannel(gameChannel);
      }
      if (!channelRefs.includes(gameChannel)) {
        this.changeChannel(defaultChannel);
      }
    }

    this.update();
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.state.selectedChannel);
    this.props.unsubscribe(); // Private channel
  }

  changeChannel = (channel) => {
    const { selectedChannel } = this.state;
    if (channel !== selectedChannel) {
      this.props.subscribe(channel);
      if (selectedChannel && !isPrivate(channel)) this.props.unsubscribe(selectedChannel);
    }
    this.setState({ selectedChannel: channel }, this.scrollBottom);
  };

  handleChannelDropdownChange = (e, data) => {
    this.changeChannel(data.value);
  };

  update = () => {
    if (this.props.toggleable === false) {
      return;
    }
    const { opened } = this.state;
    localforage.setItem('opened', opened);
  };

  open = (e) => {
    if (this.props.toggleable === false) {
      return;
    }
    const { opened } = this.state;
    if (e.target !== this.notification && e.target.tagName !== 'IMG') {
      if (!opened) {
        this.setState({ opened: true });
        this.update();
      }
    }
  };

  toggleOpen = () => {
    const { opened } = this.state;
    this.setState({ opened: !opened, unseenMessages: 0 });
  };

  chatRef = (_) => {
    this.chat = _;
  };

  endPrivateChat = (_) => {
    this.props.closePrivateRoom();
  };

  talkWrapRef = (_) => {
    this.talkWrap = _;
  };

  notificationRef = (_) => {
    this.notification = _;
  };

  handleOnMessage = (_) => {
    const { opened } = this.state;
    if (!opened) {
      this.setState((prevState) => ({ unseenMessages: prevState.unseenMessages + 1 }));
    }
    if (this.props.onMessage) {
      this.props.onMessage();
    }
    this.scrollBottom();
  };

  scrollBottom = () => {
    if (this.talkWrap) this.talkWrap.scrollTop = this.talkWrap.scrollHeight;
  };

  talkWrapClick = () => {
    if (!matchMedia('(max-width: 768px)').matches) {
      this.focus();
    }
  };

  focus = () => {
    document.getElementById('chatBox').focus();
  };

  render() {
    const { channels, channelRefs, toggleable, banned, banReason } = this.props;
    const { opened, selectedChannel, unseenMessages } = this.state;
    const chatClass = classNames([{ open: toggleable === false ? true : opened }]);
    const selectedChannelObj = channels[selectedChannel];
    const inPrivate = selectedChannel === PRIVATE;

    return (
      <div id="chat" className={chatClass} ref={this.chatRef} onClick={this.open}>
        <Online provider="Chat">
          {(online) => (!online ? <OfflineOverlay name="chat" /> : null)}
        </Online>
        {banned || (selectedChannelObj && selectedChannelObj.kicked) ? (
          <div className="ban-container">
            <span>{banReason || (selectedChannelObj && selectedChannelObj.kickReason)}</span>
          </div>
        ) : null}
        {!banned ? (
          <header className="chat__header">
            <section className="channels">
              {!isEmpty(channelRefs) ? (
                <Dropdown
                  value={selectedChannel}
                  onChange={this.handleChannelDropdownChange}
                  name="chatChannelSelect"
                  className="cs-select cs-skin-elastic chatChannelSelect"
                  id="chatChannelSelect"
                >
                  {channelRefs.map((channelRef) => (
                    <span key={channelRef}>
                      {channelRef === PRIVATE ? 'Private message MrQ' : channels[channelRef].name}
                    </span>
                  ))}
                </Dropdown>
              ) : null}
            </section>
            <section>
              <UserList channel={selectedChannel} />
            </section>
          </header>
        ) : null}

        {!banned ? (
          <div className="talkWrap" onClick={this.talkWrapClick} ref={this.talkWrapRef}>
            <MagicMove>
              <MessageList
                key={selectedChannel}
                channel={selectedChannel}
                onMessage={this.handleOnMessage}
                leftAt={this.state[selectedChannel]}
              />
            </MagicMove>
          </div>
        ) : null}
        {inPrivate ? (
          <ConfirmModal
            onConfirm={this.endPrivateChat}
            title="End chat?"
            info="Are you sure you want to end this conversation? You will not be able to start again in this chat window."
          />
        ) : null}

        {!banned && inPrivate ? (
          <div className="chat__end-private">
            <a onClick={this.props.showConfirmation}>End private chat</a>
          </div>
        ) : null}

        {!banned ? (
          <UserInput channel={selectedChannel} focus={this.focus} ref={this.chatBoxRef} />
        ) : null}
        {toggleable === false ? null : (
          <div className="chatNotification" ref={this.notificationRef} onClick={this.toggleOpen}>
            <img
              className="minimize-icon"
              src="/assets/images1/lobby/chat-minimize.svg"
              title="Minimize chat"
              alt=""
            />
            <img
              className="expand-icon"
              src="/assets/images1/lobby/chat-expand.svg"
              title="Open chat"
              alt=""
            />
            {unseenMessages !== 0 ? (
              <span className="chatNotification__counter">
                {unseenMessages > 9 ? '9+' : unseenMessages}
              </span>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  defaultChannel: Chat.selectors.getDefaultChannelRef(state),
  channels: Chat.selectors.getChannels(state),
  banned: Chat.selectors.model(state).banned,
  banReason: Chat.selectors.model(state).banReason,
  subscriptions: Chat.selectors.model(state).socket.subscriptions,
  channelRefs: Chat.selectors.getChannelRefs(state)
});

const mapDispatchToProps = (dispatch) => ({
  initialize: async (selectedChannel, subscriptions) => {
    dispatch(Chat.actions.subscribe()); // Private chat channel
    dispatch(Chat.actions.subscribe(selectedChannel));
    if (isEmpty(subscriptions) || !subscriptions[selectedChannel]) {
      if (selectedChannel && selectedChannel !== PRIVATE) {
        await Api.actions.chat.subscribers({ refName: selectedChannel })(dispatch);
      }
    }
  },
  closePrivateRoom: () => {
    Api.actions.chat.closePrivateRoom()(dispatch);
  },
  showConfirmation: () => dispatch(Modals.actions.open('confirm')),
  subscribe: async (channel) => {
    if (!isPrivate(channel)) {
      await Api.actions.chat.subscribers({ refName: channel })(dispatch);
    }
    dispatch(Chat.actions.subscribe(channel));
  },
  unsubscribe: (channel) => dispatch(Chat.actions.unsubscribe(channel))
});

export default connect(mapStateToProps, mapDispatchToProps)(_Chat);
